import React from 'react';  
import classes from './toggleSwitch.module.scss'; // or your appropriate CSS module  

interface ToggleSwitchProps {  
    isLabel1Selected: boolean;  
    setIsLabel1Selected: (value: boolean) => void;  
    label1: string; 
    label2: string;
    label3: string;
}  

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({  
    isLabel1Selected,  
    setIsLabel1Selected,  
    label1,  
    label2,
    label3  
}) => {  
    const handleToggle = () => {  
        setIsLabel1Selected(!isLabel1Selected);
    };  

    return (  
        <div className={classes.toggleSwitch}>  
            <span className={`${classes.label} ${isLabel1Selected ? classes.active : ''}`}>{label1}</span>  
            <div   
                className={`${classes.switch} ${!isLabel1Selected ? classes.active : ''}`}   
                onClick={handleToggle}  
            >  
                <div className={`${classes.toggleButton} ${!isLabel1Selected ? classes.active : ''}`}></div>  
            </div>  
            <span className={`${classes.label} ${!isLabel1Selected ? classes.active : ''}`}>  
                {label2}  
                {<span className={classes.savingsText}> {label3}</span>}  
            </span>  
        </div>  
    );  
};  

export default ToggleSwitch;  